// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"d41c19d9","453":"5f4a27ed"}[chunkId] + ".chunk.js";
};